import { formatPriceUSD } from "../../format";
import { PatientTaskBroadcastDetails, PatientTaskInstance } from "../../messages";
import { AppCaregiver } from "../../system/AppState/AppCaregiverState";
import { Visit } from "../../system/AppState/AppVisitsState";
import { getVisitHoursPerWeek } from "../AvailableVisitsMapVisitMarker";

export function getCaregiverPhotoUrl(caregiver: Pick<AppCaregiver, "photoUrl">) {
  return caregiver.photoUrl ?? "/assets/default_profile.png";
}

export function getVisitPriceAndHourTexts(visit: Visit) {
  const { price, patientInitials } = visit.publicVisitBroadcastDetails;
  const { amount: numberOfHours, type: pricingType } = getVisitHoursPerWeek(visit);
  const estimatedSalaryPerWeek = (price ?? 0) * numberOfHours;

  const getHoursText = () => {
    switch (pricingType) {
      case "LiveIn":
        return "Live In";
      case "Multiple":
        return `${numberOfHours}h/multiple`;
      case "PerWeek":
        return `${numberOfHours}h/week`;
      case "Single":
        return `${numberOfHours}h`;
    }
  };

  const priceText =
    estimatedSalaryPerWeek > 0 ? formatPriceUSD(estimatedSalaryPerWeek) : patientInitials;

  const hoursText = getHoursText();

  return { priceText, hoursText };
}

export type MainScreenActiveCard =
  | { type: "visit"; visit: Visit }
  | { type: "task"; task: PatientTaskBroadcastDetails }
  | { type: "assigned-task"; task: PatientTaskInstance }
  | { type: "caregiver" };
